export enum ModuleType {
  StoreManagement = 0,
  TreatmentManagement = 1,
  ProductManagement = 2,
  OptionsManagement = 3,
  BusinessTypeManagement = 4,
  HeadquarterManagement = 5,
  ShiftManagement = 6,
  StaffManagement = 7,
  ReservationManagement = 8,
  AgreementManegement = 9,
  SalesMedicalRecord = 10,
  StoreCMS = 11,
  GroupManagement = 12,
  CustomerManagement = 13,
  CategoryManagement = 14,

  AgreementPasswordSetting = 15,
  TaxSetting = 16,
  TimeSetting = 17,
  StoreMotivationSetting = 18,
  PaymentModeSetting = 19,
  ConsumptionTaxSetting = 20,
  ReservationSetting = 21,
  UploadIconsSetting = 22,
  CancelledReservations = 23,
  UploadTemplatesSetting = 24,
  CancellationPolicy = 25,
  InventoryManagement = 26,
  EmailManagement = 27,
  Dashboard = 28,
  TotallingManagement = 29,

}
